import React, { Fragment, useCallback, useState } from 'react'
import { toast } from 'sonner'
import PublishIcon from '@material-ui/icons/Publish'
import { Modal, Typography } from '@material-ui/core'
import Dropzone from 'react-dropzone'
import globalStyles from '../style.module.css'
import styles from './UploadCertificateModalStyle.module.css'
import { uploadRegistrationCertificate } from '../api'
import { useRegistrationCertificatesStore } from '../stores/registrationCertificateStore'
import Button from '../../../generic/Button'
import { getSelectedClients } from '../../../data/interactions'

export const UploadCertificateModal = ({ uploadSuccessCallback }) => {
	// Certificates are listed across all partners, but they are still uploaded
	// to the partner selected in the menu.
	const selectedClient = getSelectedClients()[0]

	const {
		fetchRegistrationCertificates,
		setUploadCertificateModalOpen,
		uploadCertificateModalOpen,
	} = useRegistrationCertificatesStore()

	const [uploading, setUploading] = useState(false)
	const [registrationNumber, setRegistrationNumber] = useState('')
	const [file, setFile] = useState(null)

	const handleClose = () => {
		setRegistrationNumber('')
		setUploadCertificateModalOpen(false)
		setUploading(false)
		setEffectiveDateCouldNotBeFound(false)
		setEffectiveDate('')
		setFile(null)
	}

	const onDrop = useCallback((acceptedFile) => {
		setFile(acceptedFile[0])
	}, [])

	const [effectiveDateCouldNotBeFound, setEffectiveDateCouldNotBeFound] =
		useState(false)
	const [effectiveDate, setEffectiveDate] = useState('')

	const handleSubmit = async () => {
		setUploading(true)
		try {
			const response = await uploadRegistrationCertificate({
				registrationCertificateNumber: registrationNumber,
				file,
				effectiveDate,
			})

			if (
				response.message ===
				'Registration Certificate effective date could not be found'
			) {
				setEffectiveDateCouldNotBeFound(true)
				await toast.error(
					'Could not find the certificate in the USCO. Manually add effective registration date and upload certificate.',
				)
				return
			}

			if (response.message === 'Invalid effective date format') {
				await toast.error('Invalid effective date format')
				return
			}

			if (response.status === 500) {
				await toast.error('Something went wrong. Please try again later')
				return
			}

			console.log({ response })
			handleClose()
			fetchRegistrationCertificates({
				isInitialLoad: true,
			})
			uploadSuccessCallback(response)

			await toast.success('Registration Certificate uploaded successfully')
		} catch (error) {
			console.log(error)
			await toast.error('Something went wrong. Please try again later')
		} finally {
			setUploading(false)
		}
	}

	return (
		<Fragment>
			<Modal open={uploadCertificateModalOpen} onClose={handleClose}>
				<div
					style={{
						backgroundColor: 'white',
						padding: '20px',
						width: '50vw',
						margin: 'auto',
					}}
				>
					<h3>
						Upload Registration Certificate
						{selectedClient ? ` to ${selectedClient.name}` : ''}
					</h3>
					<br />
					<br />
					<Typography variant='body2'>
						Registration Certificate number
					</Typography>
					<div className={styles.uploadInput}>
						<input
							className={globalStyles.searchInput}
							onChange={(e) => setRegistrationNumber(e.target.value)}
							placeholder={'Registration Certificate Number'}
						/>
					</div>
					{effectiveDateCouldNotBeFound && (
						<>
							<Typography variant='body2'>
								Registration Certificate Effective Date (YYYY-MM-DD)
							</Typography>
							<div className={styles.uploadInput}>
								<input
									className={globalStyles.searchInput}
									onChange={(e) => setEffectiveDate(e.target.value)}
									placeholder={'Registration Certificate Effective Date'}
								/>
							</div>
						</>
					)}
					<Dropzone
						multiple={false}
						accept='application/pdf'
						onDrop={onDrop}
						acceptStyle={{ opacity: 0.3 }}
						rejectStyle={{ background: '' }}
						style={{
							border: '3px dashed #ddd',
							padding: '50px 0 30px 0',
							textAlign: 'center',
							height: '200px',
							width: '100%',
						}}
					>
						<PublishIcon />
						{file ? (
							<>
								<br />
								<Typography variant='body2'>File selected</Typography>
								<br />
								<Typography variant='body2'>{file.name}</Typography>
							</>
						) : (
							<>
								<br />
								<Typography variant='body2'>Drop file here</Typography>
								<br />
								<Typography variant='body2'>Supports: .PDF</Typography>
							</>
						)}
					</Dropzone>
					<div style={{ display: 'flex', marginTop: '10px' }}>
						<Button onClick={handleClose} style={{ marginRight: '10px' }}>
							Cancel
						</Button>
						<Button
							onClick={handleSubmit}
							disabled={
								uploading ||
								!registrationNumber ||
								!file ||
								(effectiveDateCouldNotBeFound && !effectiveDate)
							}
						>
							Upload Certificate
						</Button>
					</div>
				</div>
			</Modal>
		</Fragment>
	)
}
